<template>
  <div class="bg">
    <div class="instagram-bg">
      <div class="instagram-symbol">
        <div class="description">
          <div>
            <img class="instagram-symbol-logo"
            :src="`${$store.state.cdnPath}/${selectedSymbol?.symbolCode}`"
            :alt="symbolLogoAlt"/>
          </div>
          <div class="symbol-info-area">
            <span class="bist-code">{{ selectedSymbol?.exchangeCode }}: {{ selectedSymbol?.symbolCode }}</span><br />
            <span class="desc">{{ selectedSymbol?.description }}</span>
          </div>
        </div>
        <div class="page-title">
          <div class="page-title-row">
            <div class="instagram-logo">
              <img height="21" width="130" v-if="$store.state.theme === 'dark-theme'" :src="`/analiz/img/${$store.state.template}-dark.svg`" :alt="labelDefinition.appLogo[$store.state.lang]" />
              <img height="21" width="130" v-if="$store.state.theme === 'light-theme'" :src="`/analiz/img/${$store.state.template}-light.svg`" :alt="labelDefinition.appLogo[$store.state.lang]" />
            </div>
            <div class="letter-area">
              <div class="title">{{ projectTitle }}</div>
              <div class="date">{{ date }}</div>
            </div>
          </div>
          <div class="filter-info" v-if="!isUnadjustedSymbol">
            <span>{{ labelDefinition.adjusted[$store.state.lang] }}: <b>{{ adjusted ? labelDefinition.adjustedYes[$store.state.lang] : labelDefinition.adjustedNo[$store.state.lang] }}</b></span>
            <span> - </span>
            <span>{{ labelDefinition.currency[$store.state.lang] }}: <b>{{ currencyLabel }}</b></span>
          </div>
        </div>
      </div>
     <div class="instagram-header-area">
      <div class="instagram-header mt-4">
        <SocialItem :text="labelDefinition.price[$store.state.lang]" :value="result.last" :font-sizes="headerFontSizes" background="var(--main-color)" color="white" width="740px"></SocialItem>
        <SocialItem :text="labelDefinition.marketValue[$store.state.lang]" :value="numberWithCommas(result.marketValue)" :font-sizes="headerFontSizes" background="var(--main-color)" color="white"></SocialItem>
        <SocialItem :text="labelDefinition.capital[$store.state.lang]" :value="result.capital" :font-sizes="headerFontSizes" background="var(--main-color)" color="white"></SocialItem>
        <SocialItem v-if="result.netLiability" :text="labelDefinition.netDebt[$store.state.lang]" :value="result.netLiability" :font-sizes="headerFontSizes" background="var(--main-color)" color="white"></SocialItem>
      </div>
      <div class="instagram-header mt-2">
        <SocialItem
          :color="$store.state.theme === 'dark-theme' ? '#FFFFFF' : 'var(--main-color)'"
          v-for="(def, index) in dataDefinition[result.type]?.panel1?.filter(a => !a.isEmpty)" 
          :text="getPanelTitle(def)"
          v-bind:key="`panel1-title${index}`"
          :value="result[def.value]"
          format-type="formatDecimal"
          :font-sizes="headerFontSizes"
          :type="def.type"
          :percentFormat="true"
          :is-positive="def.isPositive"></SocialItem>
      </div>
     </div>
      <div class="instagram-row mt-3">
          <SummaryPanel class="home-summary-panel instagram-summary-panel" :row-count="dataDefinition[result.type]?.panel2?.length">
            <template #header>
              <SummaryPanelHeaderItem :text="labelDefinition.panel2Title[$store.state.lang]" :sub-text="panel2hasMillion ? ' (x1000)' : ''"  sub-font-size="1rem" type="title" font-size="22px" font-weight="500">
              </SummaryPanelHeaderItem>
              <SummaryPanelHeaderItem v-if="showPeriodicDataPercent()" :text="`${labelDefinition.periods.yearly[$store.state.lang]} %`" font-size="22px" font-weight="500">
              </SummaryPanelHeaderItem>
              <SummaryPanelHeaderItem v-for="periodicData in result.periodicData" :text="getPeriod(periodicData.period)"
                v-bind:key="periodicData.period" font-size="22px" font-weight="500"></SummaryPanelHeaderItem>
            </template>
            <template v-for="(def, index) in dataDefinition[result.type]?.panel2" :slot="`body${(index + 1)}`">
              <SummaryPanelBodyItem v-bind:key="`panel2-title${index}`" type="text" :value="getPanelTitle(def)" font-size="22px"
                font-weight="400"  :width="tdWidths[result.type]">
              </SummaryPanelBodyItem>
              <SummaryPanelBodyItem v-bind:key="`panel2-value${index}`" v-if="showPeriodicDataPercent()"
                type="value" :check-value="true"
                :value="calculatePeriodicDataPercent(def, true)"
                font-size="22px" font-weight="500" :is-opposite="def.isOpposite">
              </SummaryPanelBodyItem>
              <SummaryPanelBodyItem v-for="periodicData in result.periodicData" v-bind:key="periodicData.period + index"
                type="value" :value="formatThousand(periodicData[def.value], panel2hasMillion)" font-size="22px" font-weight="500">
              </SummaryPanelBodyItem>
            </template>
          </SummaryPanel>
          <SummaryPanel class="home-summary-panel instagram-summary-panel mt-3" :row-count="dataDefinition[result.type]?.panel3?.length">
            <template #header>
              <SummaryPanelHeaderItem :text="labelDefinition.panel3Title[$store.state.lang]" :sub-text="panel3hasMillion ? ' (x1000)' : ''" sub-font-size="1rem" type="title" font-size="22px" font-weight="500">
              </SummaryPanelHeaderItem>
              <SummaryPanelHeaderItem v-if="showPanel3Percent" :text="`${labelDefinition.periods.yearly[$store.state.lang]} %`" font-size="22px" font-weight="500">
              </SummaryPanelHeaderItem>
              <SummaryPanelHeaderItem v-for="periodicData in panel3PeriodicData" :text="getPeriod(periodicData.period)"
                v-bind:key="periodicData.period" font-size="22px" font-weight="500"></SummaryPanelHeaderItem>
            </template>
            <template v-for="(def, index) in dataDefinition[result.type]?.panel3" :slot="`body${(index + 1)}`">
              <SummaryPanelBodyItem v-bind:key="`panel3-title${index}`" type="text" :value="def[$store.state.lang]" font-size="22px"
                font-weight="400" :width="tdWidths[result.type]">
              </SummaryPanelBodyItem>
              <SummaryPanelBodyItem v-bind:key="`panel3-value${index}`" v-if="showPanel3Percent"
                type="value" :check-value="true"
                :value="calculatePeriodicDataPercent(def, false)"
                font-size="22px" font-weight="500"
                :is-opposite="def.isOpposite">
              </SummaryPanelBodyItem>
              <SummaryPanelBodyItem v-for="periodicData in panel3PeriodicData" v-bind:key="periodicData.period + index"
                type="value" :value="formatThousand(periodicData[def.value], panel3hasMillion)" font-size="22px" font-weight="500"></SummaryPanelBodyItem>
            </template>
          </SummaryPanel>
        <div class="charts-area mt-3">
          <div v-for="def in dataDefinition[result.type]?.charts" v-bind:key="def.value" class="summary-panel-instagram chart-area">
            <div class="title text-center mt-1" :class="getTitleClass(getChartTitle(def))">{{ getChartTitle(def) }}</div>
              <BarChart
                  :id="def.value"
                  :data="getChartValues(def.value)"
                  :inflationAdjustmentPeriods="inflationAdjustmentPeriods"
                  :zeroPeriodForBarchart="zeroPeriodForBarchart"
                  width="240px"
                  :height="chartHeights[result.type]"
                  :gradient="false"
                  :theme="$store.state.theme"
                  :xaxis="barChartXaxis"
                ></BarChart>
          </div>
          <div class="summary-panel-instagram chart-area">
            <div class="title  text-center mt-1" :class="getTitleClass(labelDefinition.priceGraphic[this.$store.state.lang])">{{ labelDefinition.priceGraphic[this.$store.state.lang] }}</div>
              <LineChart2
                id="price-chart-instagram"
                :series="series"
                :period="period"
                :theme="$store.state.theme"
                width="240px"
                :height="chartHeights[result.type]"
                :xaxis="lineChartXaxis">
              </LineChart2>
          </div>
        </div>
        <div class="chart-info-container">
          <span class="chart-info">{{ labelDefinition.shareInfo[this.$store.state.lang] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import BarChart from './BarChart.vue';
import LineChart2 from './LineChart2.vue';
import SocialItem from './SocialItem.vue'
import SummaryPanel from './SummaryPanel.vue';
import SummaryPanelBodyItem from './SummaryPanelBodyItem.vue';
import SummaryPanelHeaderItem from './SummaryPanelHeaderItem.vue';
import definition from '../data-definition';

export default {
  name: 'Instagram-Page',
  props: {
    result: {
      type: Object,
      default: () => { }
    },
    bars: {
      type: Array,
      default: () => []
    },
    panel2hasMillion: {
      type: Boolean,
      default: false
    },
    panel3hasMillion: {
      type: Boolean,
      default: false
    },
    inflationAdjustmentPeriods: {
      type: Array,
      default: () => []
    },
    period: {
      type: String,
      default: ''
    },
    zeroPeriodForBarchart: {
      type: Boolean,
      default: false
    },
    adjusted: {
      type: Boolean,
      default: true
    },
    currency: {
      type: String,
      default: 'TRY'
    },
    isUnadjustedSymbol: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BarChart,
    LineChart2,
    SocialItem,
    SummaryPanel,
    SummaryPanelBodyItem,
    SummaryPanelHeaderItem
  },
  data() {
    return {
      dataDefinition: definition.dataDefinition,
      labelDefinition: definition.labelDefinition,
      timespan: null,
      barChartXaxis: {
        size: '10px',
        weight: 500
      },
      lineChartXaxis: {
        size: '10px',
        weight: 500
      },
      chartHeights: {
        general: '240px',
        factoring: '290px',
        insurance: '200px',
        bank: '230px'
      },
      tdWidths: {
        general: '272px',
        factoring: '272px',
        insurance: '292px',
        bank: '272px'
      }
    }
  },
  computed: {
    selectedSymbol() {
      return this.result.symbol ? this.$store.state.symbols.find(s => s.symbolCode === this.result.symbol) : {}
    },
    symbolLogoAlt() {
      if (!this.selectedSymbol?.symbolCode) {
        return '';
      }
      return `${this.selectedSymbol.symbolCode} - ${this.selectedSymbol.description}`;
    },
    series() {
      return [{
        data: this.bars?.map(r => {
          const date = new Date(r.time);
          return {
            x: new Date(date.getTime() - 60 * 1000 * date.getTimezoneOffset()),
            y: r.close
          }
        }),
        name: ''
      }]
    },
    projectTitle() {
      const title = this.labelDefinition.projectTitleInsagram[this.$store.state.lang];
      return title;
    },
    date() {
      const date = new Date();
      const day = date.getDate();
      const month = this.$store.state.lang === 'tr' ? 
        ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'][date.getMonth()] :
        ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][date.getMonth()];
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      
      return `${day} ${month} ${year} - ${hours}:${minutes}`;
    },
    headerFontSizes() {
      return this.$store.state.lang === 'tr' ? [16, 26] : [15, 25];
    },
    currencyLabel() {
      const map = { 'TRY': 'TL', 'USD': 'USD', 'EUR': 'EUR' };
      return map[this.currency] || this.currency;
    },
    panel3Defs() {
      return this.dataDefinition[this.result.type]?.panel3 || [];
    },
    panel3PeriodicData() {
      return this.$commonHelper.filterZeroPanelColumns(this.result.periodicData, this.panel3Defs);
    },
    showPanel3Percent() {
      if (!this.showPeriodicDataPercent()) {
        return false;
      }

      return this.$commonHelper.shouldShowPanelPercentColumn(this.panel3Defs, (def) =>
        this.calculatePeriodicDataPercent(def, false)
      );
    }
  },
  methods: {
    getPeriod(value) {
      const str = value ? value.toString() : '';
      return str && str.length == 6 ? `${str.slice(0, 4)}/${str.slice(4)}` : ''
    },
    formatThousand(value, hasMillion) {
      if (hasMillion) {
        value = parseInt(value / 1000).toString();
      } else {
        value = value ? value.toString() : '0';
      }
     
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(value))
        value = value.replace(pattern, "$1.$2");
      return value;
    },
    roundPercent(last, first, isNegativeValue, isIncome) {
      if (last && first) {
        if ((last < 0 && first > 0) || (last > 0 && first < 0) || (isIncome && last < 0 && first < 0 && last > first)) {
          return 'A.D';
        } else {
          const result = ((last - first) / Math.abs(first)) * 100;
          const value = last < 0 && first < 0 && isNegativeValue ? Math.abs(result) : result;
          return `${Math.round(value).toString()}%`;
        }
      }
  
      return '-';
    },
    getChartValues(key) {
      return (this.result.lastFivePeriods.length === 5 ? this.result.lastFivePeriods.slice(1) : this.result.lastFivePeriods).map(l => {
        return {
          text: this.getPeriod(l.period),
          value: l[key],
          period: l.period
        }
      });
    },
    numberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getChartTitle(def) {
      let key = '';
      if (this.result.isHalfYearPeriod) {
        key = `${this.$store.state.lang}_half`;
      } else {
        let periods = this.result.lastFivePeriods?.map(p => p.period) || 0;
        periods = periods.sort((a, b) => b - a);

        if (periods.length >= 2 && this.$commonHelper.getUsablePrevPeriod(periods[0]) != periods[1]) {
          key = `${this.$store.state.lang}_yearly`;
        } else {
          key = this.$store.state.lang;
        }
      }

      const key_alternative = `${key}_alternative`;

      if (this.$store.state.alternative_title_symbols.includes(this.selectedSymbol?.symbolCode) && def[key_alternative]) {
        return def[key_alternative];
      }

      return def[key];
    },
    getTitleClass(text){
      const length = text?.length;
      if (length <= 31) {
        return 'title-short';
      } else if (length <= 38) {
        return 'title-medium';
      } else {
        return 'title-long'
      }
    },
    getPanelTitle(def) {
      const key = `${this.$store.state.lang}_alternative`;

      if (this.$store.state.alternative_title_symbols.includes(this.selectedSymbol?.symbolCode) && def[key]) {
        return def[key];
      }

      return def[this.$store.state.lang];
    },
    calculatePeriodicDataPercent(def, isIncome) {
      if (this.result.periodicData.length == 3) {
          return this.roundPercent(this.result.periodicData[0][def.value], this.result.periodicData[2][def.value], def.isNegativeValue, isIncome)
      } else if (this.result.periodicData.length == 2) {
        const lastPeriod = this.result.periodicData[0]?.period;
        const prevPeriod = lastPeriod - 100;

        if (this.result.periodicData[1]?.period == prevPeriod) {
          return this.roundPercent(this.result.periodicData[0][def.value], this.result.periodicData[1][def.value], def.isNegativeValue, isIncome)
        } else {
          return 0;
        }
      } else {
         return 0;
      }
    },
    showPeriodicDataPercent() {
      if (this.result.periodicData.length == 3) {
          return true;
      } else if (this.result.periodicData.length == 2) {
        const lastPeriod = this.result.periodicData[0]?.period;
        const prevPeriod = lastPeriod - 100;

        if (this.result.periodicData[1]?.period == prevPeriod) {
          return true
        }
      }

      return false;
    }
  },
  mounted() {
    this.timespan = Date.now();
  }
}
</script>
  